import { useDispatch, useSelector } from "react-redux";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { currentPendingMainAgentChangeRequests } from "../../../redux/selector/mainAgentChangeRequestSelector";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import TopNavigationBar from "../../TopNavigationBar";
import CheckboxForm from "../../../components/CheckBoxForm";
import { useEffect, useState } from "react";
import { 
  Paragraph, 
  Button,
  ErrorMark,
  ErrorWithString, 
} from "../../../components/RegularComponents";
import { fullName, ValidateString } from "../../../app/utils";
import { 
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  REQUEST_STATUS,
  ROUTE_PATH 
} from "../../../app/constants";
import DateSelectionForm from "../../../components/DateSelectionForm";
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from "../../../app/errors";
import { push } from "connected-react-router";
import { setCurrentMainAgentChangeRequestDataObject } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";

export const MainAgentChangeRequestReason = (props) => {
    const {isModal = false, onEditSave = () => {}} = props
    const {applicationMode} = props.match.params
    const {agencyApplication} = useSelector(agencyApplicationSelector) || {};
    const {mainAgentChangeRequest} = useSelector(currentPendingMainAgentChangeRequests);
    const serverSaveRequest = useSelector(state => state.primaryAgencyApplication.serverRequestStatus)
    const companyName = agencyApplication?.name;
    const personData = agencyApplication?.businessLicenceData?.personData;
    const currentMainAgentName = fullName(personData);
    const licencingSubType = agencyApplication?.licencingSubType;
    const applicationType = applicationTypeFromLicenceSubType(licencingSubType)
    const mainAgentTypeString = (applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE) ? 'Principal Broker' : 'Compliance Officer';

    const dispatch = useDispatch();
    const regulationEmail = "mortgageregulation@novascotia.ca";

    const [isCurrentlyActiveAgent, setIsCurrentlyActiveAgent] = useState(false);
    const [effectiveDate, setEffectiveDate] = useState();
    const [reasonForChange, setReasonForChange] = useState();
    const [showValidationError, setShowValidationError] = useState(false);
    const [applicationSaveError, setApplicationSaveError] = useState(false);
    const [dateError, setDateError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [reasonError, setReasonError] = useState(VALIDATION_ERROR.NO_ERROR)

    useEffect(() => {
      const changeRequestData = mainAgentChangeRequest?.changeRequestData ?? {}
      setReasonForChange(changeRequestData.reasonForChange);
      setEffectiveDate(changeRequestData.effectiveDate);
      setIsCurrentlyActiveAgent(changeRequestData.isCurrentlyActiveAgent);
    }, [mainAgentChangeRequest])

    const validateDate = () => { 
        const ret = ValidateString(effectiveDate, VALIDATION_TYPE.DATE_VALID)
        setDateError(ret)
        return (ret === VALIDATION_ERROR.NO_ERROR)
    }

    const validateReasonString = () => {
      const ret = ValidateString(reasonForChange,VALIDATION_TYPE.STRING_NON_EMPTY);
      setReasonError(ret)
      return (ret === VALIDATION_ERROR.NO_ERROR)
    }

    const isDateValid = () => {
      if(showValidationError) {
        return (dateError === VALIDATION_ERROR.NO_ERROR)
    }

    return true
    }

    const isReasonValid = () => { 
      if(showValidationError) {
          return (reasonError === VALIDATION_ERROR.NO_ERROR)
      }

      return true
  }

    const handleSave = () => {
      setShowValidationError(false);
      const dateValid = validateDate();
      const reasonValid = validateReasonString();

      if (dateValid && reasonValid) {
        const changeRequestData = mainAgentChangeRequest?.changeRequestData ?? {}
        // push the date, reason and confirmation
        dispatch(setCurrentMainAgentChangeRequestDataObject({
          ...changeRequestData,
          isCurrentlyActiveAgent,
          effectiveDate,
          reasonForChange
        }))

        return true 
      }

      setShowValidationError(true);

      return false;
    }

    const handleSaveAndNext = () => {
      if(handleSave()) {
        //Main app + parent app has to be updated
        dispatch(saveBusinessLicenceApplicationData(
          applicationTypeFromLicenceSubType(licencingSubType), applicationMode))
          .then(() => {
            dispatch(
              push(
                `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_NEW_EMAIL}`
              )
            );
          })
          .catch((err) => {
            setApplicationSaveError(true);
          });
      }
      
    }

    const handleSaveAndClose = () => {
      if(handleSave()) {
        onEditSave();
      }
    };

    return (
    <div className={!isModal ? "container" : ""}>
        {!isModal && (
        <>
          <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <h1>{`${mainAgentTypeString} Change Request`}</h1>
            </div>
          </div>

          <div className="row topMarginMedium">
            <div className="col-lg-1">
              <CheckboxForm
                id="currently-active-broker-checkbox"
                checked={isCurrentlyActiveAgent}
                value={isCurrentlyActiveAgent}
                labelStyle={{ fontWeight: "normal !important" }}
                onCheckBoxChange={(val) => {
                  setIsCurrentlyActiveAgent(val);
                }}
              />
            </div>
            <div className="col-lg-7">
              <Paragraph
                style={{ marginLeft: "-20px" }}
                id="currently-active-broker-checkbox-text"
                text={[
                  `I am ${currentMainAgentName}, the current ${mainAgentTypeString} of the company.`,
                ]}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <Paragraph
                id="currently-active-broker-helper-text"
                text={[
                  `If you are not the current ${mainAgentTypeString} for ${companyName}, please contact ${regulationEmail}.`
                ]}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <fieldset className={"ns-fieldset" + (!isDateValid() ? " ns-fieldset-message-error" : "")}>
                <label
                  id="principal-broker-change-effective-date-label"
                  className="ns-label"
                >
                  {`Start Date of new ${mainAgentTypeString}`}
                </label>
              <p>Enter a Day Month Year. For example 17 11 2007</p>
              <DateSelectionForm
                id={"principal-broker-change-effective-date-date"}
                date={effectiveDate}
                showValidationError={showValidationError}
                onDateChange={(date) => {
                  setDateError(VALIDATION_ERROR.NO_ERROR);
                  setEffectiveDate(date);
                }}
              />
            </fieldset>
            </div>
          </div>
        
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <fieldset className={"ns-fieldset" + (!isReasonValid() ? " ns-fieldset-message-error" : "")}>
                <label
                  id={"change-reason-description-label"}
                  className="ns-label"
                  htmlFor={"change-reason-description-text"}
                >
                  Reason for the request
                </label>
                <div className="help-block">Maximum of 3000 characters</div>
                {!isReasonValid() && 
                <span id={"change-request-reason-input-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.CHANGE_REQUEST_REASON_EMPTY)}
                </span>}
                <textarea
                  type="text"
                  className={(!isReasonValid() ? "fw-30 ns-input--error" : "fw-30 ns-input")}
                  id={"change-reason-description-text"}
                  name={"change-reason-description-text"}
                  maxLength="3000"
                  rows="4"
                  value={reasonForChange}
                  onChange={(e) => {
                    setReasonError(VALIDATION_ERROR.NO_ERROR);
                    setReasonForChange(e.target.value);
                  }}
                />
              </fieldset>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-lg-8">
                <Paragraph 
                  id="currently-active-broker-info-text"
                  text={[
                    `After you submit this request for ${mainAgentTypeString}, you will be provided with a link for the new ${mainAgentTypeString} to apply.`,
                  ]}
                />
            </div>
          </div>

          <div className="row">
            <div className={"col-lg-4"}>
              <Button
                id="change-reason-save-button"
                style={{ margin: "0 10px 10px 0" }}
                buttonType={"regular_primary"}
                text={!isModal ? "Save and next" : "Save and close"}
                onClick={!isModal ? handleSaveAndNext : handleSaveAndClose}
                showSpinner={!applicationSaveError && 
                  (serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
                disabled={(serverSaveRequest === REQUEST_STATUS.IN_PROGRESS)}
              />
              {showValidationError && ErrorMark()}
              {showValidationError && (
                <div className="ns-error-message">
                  <span className="ns-visually-hidden">Error:</span>
                  {ERROR_STRING.CHECK_FIELDS}
                </div>
              )}
              {applicationSaveError && ErrorMark()}
              {applicationSaveError && (
                <div className="ns-error-message help-block topMarginNormal">
                  <span className="ns-visually-hidden">Error:</span>
                  {ERROR_STRING.APPLICATION_SAVE_ERROR}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
    );
}
